import { AfterViewInit, ChangeDetectorRef, Component, DoCheck, ElementRef, Input, NgZone, OnChanges, OnDestroy, OnInit, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from "@angular/core";
import { I18n } from "../i18n.service";
import { SessionService } from "../session/session.service";
import { AppState } from "../app.service";
import * as AddToCalendar from "../../../vendor/add-to-calendar-buttons/add-to-calendar.js";
import * as moment from "moment";
import { Path } from "../path/path-v2.model";
import { CordovaService } from "../cordova.service";
import { AlertController, ModalController, PickerController, Platform } from "@ionic/angular";
import { DomSanitizer } from "@angular/platform-browser";
import { HomeUiService } from "../new-design/home-ui.service";
import { AlertNotifyComponent } from "../alert-notify/alert-notify.component";
import { PathRegistration } from "../user/path-registration.model";
import { UserService } from "../user/user.service";
import { ToasterService } from "../toaster.service";
import { FirebaseX } from "@awesome-cordova-plugins/firebase-x/ngx";
import { AnalyticsServiceService } from "../services/analytics-service.service";
import { CalendarService } from "../calendar.service";
import { Client } from "../client/client.model";
import mixpanel from 'mixpanel-browser';
import { MatDialog } from "@angular/material/dialog";
import { NotificationConfirmationPopupComponent } from "../notification-confirmation-popup/notification-confirmation-popup.component";
import { HomeV5Service } from "../pages/home-v5/home-v5.service";
import { User } from "../user/user.model";
import { SpinnerService } from "../spinner.service";
import { MobileChatBoardComponent } from "../pages/mobile-chat-board/mobile-chat-board.component";
import { MyCommitmentsComponent } from "../my-commitments/my-commitments.component";
import { Router } from "@angular/router";
import { NativeService } from "../services/native.service";
import { Constants } from "../constants/constants";
import { AndroidPermissions } from "@awesome-cordova-plugins/android-permissions/ngx";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";
import { environment } from "src/environments/environment";
import { ChapterStepsModalComponent } from "../new-design/chapter-steps-modal/chapter-steps-modal.component";
import { animate, query, stagger, style, transition, trigger } from "@angular/animations";
import { KyperDataApiService } from "../services/kyper-data-api.service";
import { CalendarCopyService } from 'src/app/calendar-copy.service';

export interface CalendarParams {
  title: String;
  startDate: Date;
  endDate: Date;
  eventLocation: String;
  notes: String;
  endEventTime: any;
  frequency: string;
}
export interface UpdateUser {
  [updateUser: string]: any;
}
declare var $: any;
declare var FCMPlugin: any
const defaultColumnOptions = [
  [
    "00:00", "00:30", "01:00", "01:30",
    "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00",
    "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30",
    "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00",
    "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30",
    "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "24:00"
  ]
]
export interface UpdatePathRegistration {
  [updatePathRegistration: string]: any;
}

@Component({
  selector: "app-onboarding-learning-notification",
  templateUrl: "./onboarding-learning-notification.component.html",
  styleUrls: ["./onboarding-learning-notification.component.scss"],
    animations: [
      trigger('animateContent', [
        transition(':enter', [
          query(':scope > *', [
            style({ opacity: 0, transform: 'translateY(8px)' })
          ], { optional: true }),

          query(':scope > *', [
            stagger(100, [
              animate(
                '800ms cubic-bezier(0.76, 0, 0.24, 1)',
                style({ opacity: 1, transform: 'translateY(0)' })
              )
            ])
          ], { optional: true })
        ]),

        transition(':leave', [
          animate(
            '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
            style({ opacity: 0, transform: 'translateY(-75px)' })
          )
        ])
      ]),
      trigger('activeChapterRow', []),
      trigger('deactiveChapterRow', []),
      trigger('emptyPlaceholder', [])
    ]
})
export class OnboardingLearningNotificationComponent
  implements OnInit, AfterViewInit, OnDestroy, DoCheck, OnChanges
{
  @Input() learningScreenData;
  @Input() managerEmailScreenData;
  @Input() screenId;
  @Input() accountabilityEmailData;
  @Input() profileScreenData;
  @Input() currentScreen
  @Input() pathPersonalizationData;
  @Input() progressItems = []
  @Input() currentIndex = 0
  isMobile;
  @Input() currentDay;
  confirmedTime;
  hasNativeCalendar: boolean; // LUMBA-1421
  cloudCalendarExpanded: boolean; // LUMBA-1421
  cloudCalendarSet: boolean; // LUMBA-1421
  morningTime: boolean;
  lunchTime: boolean;
  atWorkTime: boolean;
  homeTime: boolean;
  bedTime: boolean;
  isVideoViewed = false;
  isTimePickerCard: boolean;
  isTimeSelectCard: boolean;
  selectedTime: any;
  isMobileWebIos = false;
  dailyStepsArrayInfo;
  userShuffledChapters;
  isMobileWeb=false;
  itemPublish: number = 22;
  managerEmail: string = "";
  managerEmails: string[] = [];
  userUpdate: UpdateUser;
  confirmationCalendartime;
  destroyed$ = new Subject<boolean>();
  generatePopup: boolean = false;
  @ViewChild("calendarButtonsContainer") calendarButtonsContainer;
  isShowed: boolean = false;
  dailyRoutine = [
    { title: this.i18n.t("After waking up"), time: null },
    { title: this.i18n.t("When starting work"), time: null },
    { title: this.i18n.t("Lunchtime"), time: null },
    { title: this.i18n.t("When finishing work"), time: null },
    { title: this.i18n.t("Before bed"), time: null },
  ];
  customPickerOptions: {
    buttons: { text: string; handler: (time: any) => void }[];
  };
  currIndex: any;
  defaultTime: string = "07:00";
  calendarParams: CalendarParams;
  currentPath: Path;
  learningTime;
  pathRegistration;
  start: any;
  end: any;
  endDate: any;
  selectedTimeOption = 0;
  @Input() isDaypartSelectionScreen: boolean;
  @Input() isDaypartConfirmationScreen: boolean;
  @Input() isNotificationSettingsCalenderScreen: boolean;
  @Input() currentScreenId;
  pushNotificationsEnabled: boolean;
  emailReminderEnabled: boolean = true;
  pushReminderEnabled: boolean;
  socialReminderEnabled: boolean;
  socialEmailReminder: boolean;
  loading: boolean = false;
  public updatePathRegistration: UpdatePathRegistration;
  currentUser;
  currentClient: Client;
  accountabilityEmails;
  arrayOfAccountabilyEmails: string[] = [];
  accountablityEmail = "";
  selectedDayPartType;
  photoUrl: any;
  isPhotoUploaded: boolean;
  label: any;
  dataRefresher: any;
  isManagerEmailAdded;
  @ViewChild("fileInput") fileInput: ElementRef;
  @ViewChild("profileBodyMobile") profileBodyMobile!: ElementRef;
  @ViewChild("profileBodyDesktop") profileBodyDesktop!: ElementRef;
  innerBodyHtml: any;
  @ViewChild("cardSubtextMobile") cardSubtextMobile!: ElementRef;
  @ViewChild("cardSubtextDesktop") cardSubtextDesktop!: ElementRef;
  @ViewChild("calendarParaMobile") calendarParaMobile!: ElementRef;
  @ViewChild("calendarParaDesktop") calendarParaDesktop!: ElementRef;
  innerLearningBodyHtml: any;
  @ViewChildren("managerEmailBodyRef") managerEmailBodyRefs!: QueryList<ElementRef>;
  innerManagerEmailBodyHtml: any;
  @ViewChildren('toggleIndex', { read: ElementRef }) toggleIndexEls: QueryList<ElementRef>;
  resetCalenderData = false;
  processedCommitmentNotifications: Set<number> = new Set();
  processedCommunityNotifications: Set<number> = new Set();
  chaptersInfo: any[] = [];
  finalSortedChaptersInfo: any[] = []
  initialChapterStepsInfo = [];
  finalChaptertepsInfo = [];
  finalizedChapterIds: any[] = []
  deselectedChapterIds: number[] = [];
  checkedChapters: any[] = [];
  uncheckedChapters: any[] = [];
  isReorderDisabled: Set<number> = new Set();
  animatingChapterIds: Set<number> = new Set();
  isTransitioning: boolean = false;
  isInitialLoad: boolean = true;
  private dragOccurred = false;
  chapterAnimationsEnabled = false;
  selectedDay: number;
  selectedDate: string =null;
  isWeeklyEnabled
  selectedDayName =null;
  hasChaptersScrollbar = false;
  showChaptersScrollToBottom = false;
  private readonly BOTTOM_THRESHOLD = 1;
  private chaptersResizeObserver!: ResizeObserver;
  private readonly PHOTO_MAX_EDGE = 720;
  private readonly PHOTO_JPEG_QUALITY = 0.8;
  private readonly PHOTO_SKIP_RESIZE_BYTES = 300 * 1024;
  constructor(
    private calendarCopy: CalendarCopyService,
    private i18n: I18n,
    private appState: AppState,
    private cordovaService: CordovaService,
    public platform: Platform,
    private userService: UserService,
    private toastrService: ToasterService,
    private pickerController: PickerController,
    public homeUiService: HomeUiService,
    public keyboard: Keyboard,
    private modalCtrl: ModalController,
    private dialog: MatDialog,
    private analyticsService: AnalyticsServiceService,
    private calendarService: CalendarService,
    private firebaseX: FirebaseX,
    private sessionService: SessionService,
    private homeService: HomeV5Service,
    private spinnerService: SpinnerService,
    private alertController: AlertController,
    private router: Router,
    private permissions: AndroidPermissions,
    private kyperApiService: KyperDataApiService,
    private native: NativeService,
    private ngZone: NgZone,
    private renderer: Renderer2,
    private _sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef
  ) {
    this.customPickerOptions = {
      buttons: [
        {
          text: this.i18n.t("Cancel"),
          handler: (time) => {
            return true;
          },
        },
        {
          text: this.i18n.t("Confirm"),
          handler: (time) => {
            this.afterWakingUp(time);
          },
        },
      ],
    };
    this.pathRegistration = this.appState.get("pathRegistration");
    this.currentPath = this.appState.get("currentPath");
    this.selectedDayPartType = this.pathRegistration?.selectedDayPart;
    this.isWeeklyEnabled = this.currentPath?.enabledAttributes?.reminder_type=="weekly" ?true: false;
    this.currentUser = this.appState.get("currentUser");
    this.chaptersInfo = this.currentPath?.kyperChapters
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.managerEmails = [...(this.currentUser?.managerEmails || [])];
    this.currentClient = this.appState.get("currentClient");
    let learningTime = localStorage.getItem("learningTime");
    if (learningTime) {
      this.learningTime = learningTime;
    } else {
      if (this.pathRegistration && this.pathRegistration.pathData) {
        this.learningTime = this.pathRegistration.pathData.loginReminderTime;
      }
    }

    if (this.learningTime != null) {
      this.getConfirmedTimeInNormalMode(this.learningTime);
    }

    this.isMobile = appState.get("isMobile");
    this.accountabilityEmails = this.appState.get("accountabilityEmails");
    if (this.accountabilityEmails) {
      this.arrayOfAccountabilyEmails = [...this.accountabilityEmails];
    }
    const draft = this.appState.get("accountabilityEmailDraft");
    if (draft) {
      this.accountablityEmail = draft;
    }
    // A manager-email draft means the learner was mid-edit (typing into the add-box) when this
    // screen was rebuilt: restore their half-typed text instead of dropping it. Cleared once the
    // draft is added as a chip, and in ngOnDestroy, so closing and reopening shows what the server has.
    const managerDraft = this.appState.get("managerEmailDraft");
    if (managerDraft != null) {
      this.managerEmail = managerDraft;
      this.isManagerEmailAdded = managerDraft;
    }
    const w: any = window;
    this.hasNativeCalendar =
      this.cordovaService.onCordova && w && w.plugins && w.plugins.calendar;
    // this.prepareCalendarParams();
    this.isTimePickerCard = false;
    this.isTimeSelectCard = true;
  }

  addManagerEmailChip(email: any) {
    let normalizedEmail = email?.trim();
    // Outlook-style paste "Name <addr@x.com>": keep only the bracketed address.
    const angleBracketMatch = normalizedEmail?.match(/<([^<>]+)>\s*$/);
    if (angleBracketMatch) {
      normalizedEmail = angleBracketMatch[1].trim();
    }
    normalizedEmail = normalizedEmail?.toLowerCase();
    if (!this.sessionService.validateEmail(normalizedEmail)) {
      this.toastrService.warning(this.i18n.t("Please enter valid email!"));
      return;
    }
    if (this.managerEmails.some(e => e?.trim()?.toLowerCase() === normalizedEmail)) {
      this.toastrService.warning(this.i18n.t("This email has already been added!"));
      return;
    }
    this.managerEmails.push(normalizedEmail);
    this.managerEmail = "";
    this.appState.set("managerEmailDraft", null);
    this.isManagerEmailAdded = undefined;
    mixpanel.track('In Steps-Manager Email Added', {
      currentDay: this.currentDay,
      totalEmails: this.managerEmails.length,
      userId: this.currentUser?.id,
      pathId: this.currentPath?.id
    });
    this.pushManagerEmails(this.currentDay, true);
  }

  removeManagerEmailChip(email: any) {
    const index = this.managerEmails?.indexOf(email);
    if (index > -1) {
      this.managerEmails?.splice(index, 1);
      mixpanel.track('In Steps-Manager Email Removed', {
        currentDay: this.currentDay,
        totalEmails: this.managerEmails.length,
        userId: this.currentUser?.id,
        pathId: this.currentPath?.id
      });
      this.pushManagerEmails(this.currentDay);
    }
  }

  pushManagerEmails(currentDay?, isAdd = false) {
    const answers = {};
    this.homeUiService.saveManagerEmailAddress(
      answers, this.managerEmails[0], currentDay,
      this.managerEmailScreenData?.screenContentId, this.managerEmailScreenData?.stepId,
      this.managerEmailScreenData?.screenId, this.managerEmailScreenData,
      this.managerEmails, isAdd
    );
    this.currentUser['managerEmails'] = this.managerEmails;
  }

  fechImageUrl(screenContent) {
    let screenImageUrl = screenContent?.screen?.content?.media?.type == 'image' &&screenContent?.screen?.content?.media?.url?.trim()?.length > 0 ? screenContent?.screen?.content?.media?.url : null;
    let screenAssetsImageUrl = screenContent?.assets?.length > 0 ? screenContent?.assets?.filter(media => media.assetType == 'image' && media.url && media.url?.trim()?.length > 0)?.[0]?.url : null
    return screenImageUrl || screenAssetsImageUrl ;
  }
  fetchChaptersSteps() {

    if (this.chaptersInfo?.length > 0 && (this.screenId == 'daily-content-screen-path-personalization' || this.pathPersonalizationData)) {
      // Use unsubmitted temp reorder if it exists, otherwise fall back to last saved order
      const tempReorderIds = this.appState.get('tempReorderedChapterIds');
      const effectiveShuffledChapters = tempReorderIds?.length > 0
        ? { ...this.userShuffledChapters, chapterOrder: tempReorderIds }
        : this.userShuffledChapters;

      // Reorder chapters as per chapterorder
      if (effectiveShuffledChapters && effectiveShuffledChapters?.chapterOrder) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !effectiveShuffledChapters.chapterOrder.includes(c.id));

        const orderedChapters = effectiveShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      }
      else {
        // Find the chapter that contains the path personalization step
        const ppChapterIdx = this.chaptersInfo.findIndex(chapter =>
          chapter.steps?.some((step: any) => step.position === this.pathPersonalizationData?.step)
        );
        // Display: exclude all chapters up to and including the pp chapter —
        // they are still included in the API payload via buildChaptersOrderInput.
        if (ppChapterIdx !== -1) {
          this.finalSortedChaptersInfo = this.chaptersInfo.slice(ppChapterIdx + 1);
        } else {
          this.finalSortedChaptersInfo = this.chaptersInfo;
        }
      }

      // // Attach steps for each chapter based on start_step & end_step
       if (effectiveShuffledChapters && effectiveShuffledChapters?.chapterOrder) {
         const chaptersInfoIds = this.chaptersInfo?.map(c => c.id) ?? [];
         const shuffledOrderIds = effectiveShuffledChapters?.chapterOrder ?? [];
         const isSameOrder = chaptersInfoIds.length === shuffledOrderIds.length &&
           chaptersInfoIds.every((id, i) => id === shuffledOrderIds[i]);

         const excludePersonalizationChapter = (chapters: any[]) => {
           const idx = chapters.findIndex(chapter =>
             chapter.steps?.some((step: any) => step.position === this.pathPersonalizationData?.step)
           );
           return idx !== -1 ? chapters.slice(idx + 1) : chapters;
         };

         if (isSameOrder) {
           this.finalSortedChaptersInfo = excludePersonalizationChapter(this.chaptersInfo);
         }
         else {
           this.finalSortedChaptersInfo = excludePersonalizationChapter(this.finalSortedChaptersInfo ?? this.chaptersInfo);
         }
         this.finalSortedChaptersInfo = this.finalSortedChaptersInfo?.map(chapter => {
           //  startIndex = endIndex + 1
           //  endIndex = startIndex+ (chapter.endStep - chapter.startStep)
           //  const includedSteps = this.dailyStepsArrayInfo.filter(
           //    s => s.step >= startIndex && s.step <= endIndex
           //  );
           const includedSteps = chapter?.steps;

           return { ...chapter, steps: includedSteps };
         });
       }
       else {
          this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
            const includedSteps = chapter.steps
        //       this.dailyStepsArrayInfo.filter(
        //   s => s.step >= chapter.startStep && s.step <= chapter.endStep
        // );
        return { ...chapter, steps: includedSteps };
      });
       }
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['profileScreenData']) {
      this.innerBodyHtml = this._sanitizer.bypassSecurityTrustHtml(
        this.profileScreenData?.screen?.content?.body ?? ''
      );
    }
    if (changes['learningScreenData']) {
      this.innerLearningBodyHtml = this._sanitizer.bypassSecurityTrustHtml(
        this.learningScreenData?.screen?.content?.body ?? ''
      );
    }
    if (changes['managerEmailScreenData']) {
      this.innerManagerEmailBodyHtml = this._sanitizer.bypassSecurityTrustHtml(
        this.managerEmailScreenData?.screen?.content?.body ?? ''
      );
      setTimeout(() => this.changeSubTextFont());
    }
  }

  changeSubTextFont(): null {
    if (this.profileBodyMobile?.nativeElement) {
      this.applyStylesToAllInnerTags(this.profileBodyMobile.nativeElement);
    }
    if (this.profileBodyDesktop?.nativeElement) {
      this.applyStylesToAllInnerTags(this.profileBodyDesktop.nativeElement);
    }
    if (this.cardSubtextMobile?.nativeElement) {
      this.applyStylesToAllInnerTags(this.cardSubtextMobile.nativeElement);
    }
    if (this.cardSubtextDesktop?.nativeElement) {
      this.applyStylesToAllInnerTags(this.cardSubtextDesktop.nativeElement);
    }
    if (this.calendarParaMobile?.nativeElement) {
      this.applyStylesToAllInnerTags(this.calendarParaMobile.nativeElement);
    }
    if (this.calendarParaDesktop?.nativeElement) {
      this.applyStylesToAllInnerTags(this.calendarParaDesktop.nativeElement);
    }
    this.managerEmailBodyRefs?.forEach(ref => {
      if (ref?.nativeElement) {
        this.applyStylesToAllInnerTags(ref.nativeElement);
      }
    });
    return null;
  }

  applyStylesToAllInnerTags(element: HTMLElement) {
    if (!element) { return; }
    const childElements = Array.from(element.children);
    childElements.forEach((childElement: Element) => {
      const tagName = childElement.tagName.toLowerCase();
      if (tagName === 'ol' || tagName === 'ul') {
        this.renderer.setStyle(childElement, 'list-style', 'none');
        this.renderer.setStyle(childElement, 'padding-left', '1.5em');
      }
      if (tagName === 'li') {
        const dataList = childElement.getAttribute('data-list');
        const qlUi = childElement.querySelector('.ql-ui');
        if (qlUi) { this.renderer.setStyle(qlUi, 'display', 'none'); }
        if (dataList === 'bullet') {
          this.renderer.setStyle(childElement, 'list-style-type', 'disc');
          this.renderer.setStyle(childElement, 'display', 'list-item');
          this.renderer.setStyle(childElement, 'margin-left', '1em');
        } else if (dataList === 'ordered') {
          this.renderer.setStyle(childElement, 'list-style-type', 'decimal');
          this.renderer.setStyle(childElement, 'display', 'list-item');
          this.renderer.setStyle(childElement, 'margin-left', '1em');
        }
      }
      this.applyStylesToAllInnerTags(childElement as HTMLElement);
    });
  }


  @ViewChild('chaptersScrollContainer')
  set chaptersScrollContainer(el: ElementRef) {
    if (el) {
      setTimeout(() => {
        this.initChaptersResizeObserver(el.nativeElement);
      }, 100);
    } else {
      this.chaptersResizeObserver?.disconnect();
    }
  }

  initChaptersResizeObserver(el: HTMLElement) {
    this.chaptersResizeObserver?.disconnect();
    this.hasChaptersScrollbar = el.scrollHeight > el.clientHeight;
    this.showChaptersScrollToBottom = el.scrollHeight - el.scrollTop - el.clientHeight > this.BOTTOM_THRESHOLD;
    this.cdRef.detectChanges();

    this.chaptersResizeObserver = new ResizeObserver(() => {
      this.hasChaptersScrollbar = el.scrollHeight > el.clientHeight;
      this.showChaptersScrollToBottom = el.scrollHeight - el.scrollTop - el.clientHeight > this.BOTTOM_THRESHOLD;
      this.cdRef.detectChanges();
    });
    // el has a fixed height (height: 100% of its parent), so its own box size never changes when
    // inner content grows/settles asynchronously. Observe its children too so late-rendering
    // content still triggers a recheck of el's scrollHeight vs clientHeight.
    this.chaptersResizeObserver.observe(el);
    Array.from(el.children).forEach(child => this.chaptersResizeObserver.observe(child));
  }

  bottomOnChaptersScroll(elRef: ElementRef | HTMLElement): void {
    const el = (elRef as ElementRef)?.nativeElement ?? elRef as HTMLElement;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    this.showChaptersScrollToBottom = distanceFromBottom > this.BOTTOM_THRESHOLD;
    this.cdRef.detectChanges();
  }

  scrollChaptersToBottom(elRef: ElementRef | HTMLElement): void {
    const el = (elRef as ElementRef)?.nativeElement ?? elRef as HTMLElement;
    this.showChaptersScrollToBottom = false;

    el.scrollTo({ top: el.scrollHeight - el.clientHeight, behavior: 'smooth' });

    let scrollEndFired = false;
    const checkScrollEnd = () => {
      scrollEndFired = true;
      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      this.showChaptersScrollToBottom = distanceFromBottom > this.BOTTOM_THRESHOLD;
      this.cdRef.detectChanges();
    };

    el.addEventListener('scrollend', checkScrollEnd, { once: true });
    setTimeout(() => { if (!scrollEndFired) checkScrollEnd(); }, 500);
  }

  private rebuildPersonalizationLists() {
    this.currentPath = this.appState.get('currentPath') ?? this.currentPath;
    this.userShuffledChapters = this.appState.get('userShuffledChapters')
      ?? this.userShuffledChapters
      ?? this.currentPath?.userChapter;

    const userChapter: any = this.userShuffledChapters;
    const tempReorderIds: number[] = this.appState.get('tempReorderedChapterIds') ?? [];
    const savedOrder: number[] = userChapter?.chapterOrder ?? userChapter?.chapter_order ?? [];
    const effectiveOrder: number[] = tempReorderIds.length > 0 ? tempReorderIds : savedOrder;
    const inProgressId: number | undefined = userChapter?.id ?? userChapter?.chapter_id;

    const orderById = (chapters: any[]) => {
      if (!effectiveOrder.length) return [...chapters];
      const inOrder = effectiveOrder.map(id => chapters.find(c => c?.id === id)).filter(Boolean) as any[];
      const remaining = chapters.filter(c => !effectiveOrder.includes(c?.id));
      return [...inOrder, ...remaining];
    };
    const excludeInProgress = (chapters: any[]) => {
      if (this.pathPersonalizationData?.step !== undefined) {
        const filtered = chapters.filter(c =>
          !c.steps?.some((s: any) => s.position <= this.pathPersonalizationData?.step)
        );
        return filtered.length > 0 ? filtered : chapters;
      }
      if (inProgressId !== undefined && inProgressId !== null) {
        return chapters.filter(c => c?.id !== inProgressId);
      }
      return chapters;
    };

    if (!this.currentPath?.enabledAttributes?.chapter_skip) {
      // Legacy mode: kyperChapters has all chapters; build finalSortedChaptersInfo only.
      const allChapters: any[] = this.currentPath?.kyperChapters ?? [];
      if (allChapters.length === 0) return;
      this.chaptersInfo = allChapters;
      this.finalSortedChaptersInfo = excludeInProgress(orderById(allChapters));
      this.finalizedChapterIds = this.finalSortedChaptersInfo.map(c => c?.id);
      this.checkedChapters = this.finalSortedChaptersInfo;
    } else {
      // New mode: kyperChapters = selected, deselectedChapters = deselected.
      const isFinalised: boolean = userChapter?.is_finalised ?? userChapter?.isFinalised ?? false;
      const pendingInput = this.appState.get('pendingChaptersOrderInput');
      const tempCheckedOrder: number[] = pendingInput?.selected_chapter_ids ?? [];
      const tempAllOrder: number[] = pendingInput?.chapter_order ?? [];
      const tempUncheckedOrder: number[] = tempAllOrder.filter(id => !tempCheckedOrder.includes(id));
      const allChaptersPool: any[] = [
        ...(this.currentPath?.kyperChapters ?? []),
        ...(this.currentPath?.deselectedChapters ?? [])
      ];
      let selected: any[];
      let deselected: any[];
      if (isFinalised) {
        selected = this.currentPath?.kyperChapters ?? [];
        deselected = this.currentPath?.deselectedChapters ?? [];
      } else {
        const chapterOrder: number[] = userChapter?.chapterOrder ?? userChapter?.chapter_order ?? [];
        const selectedIds: number[] = userChapter?.selectedChapterIds ?? userChapter?.selected_chapter_ids ?? [];
        if (chapterOrder.length > 0 && selectedIds.length > 0) {
          selected = selectedIds.map(id => allChaptersPool.find(c => c?.id === id)).filter(Boolean);
          const deselectedIds = chapterOrder.filter(id => !selectedIds.includes(id));
          deselected = deselectedIds.map(id => allChaptersPool.find(c => c?.id === id)).filter(Boolean);
        } else {
          selected = this.currentPath?.kyperChapters ?? [];
          deselected = [];
        }
      }
      if (selected.length === 0 && deselected.length === 0) return;
      this.chaptersInfo = [...selected, ...deselected];
      this.checkedChapters = excludeInProgress(orderById(selected));
      if (tempCheckedOrder.length > 0) {
        this.checkedChapters = tempCheckedOrder.map(id => excludeInProgress(orderById(allChaptersPool)).find(c => c?.id === id)).filter(Boolean);
      }
      this.uncheckedChapters = tempUncheckedOrder.length > 0
        ? tempUncheckedOrder.map(id => allChaptersPool.find(c => c?.id === id)).filter(Boolean)
        : orderById(deselected);
      this.deselectedChapterIds = this.uncheckedChapters.map(c => c?.id).filter(id => id != null);
      this.finalizedChapterIds = this.checkedChapters.map(c => c?.id);
      this.finalSortedChaptersInfo = [...this.checkedChapters, ...this.uncheckedChapters];
    }
  }
  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.dailyStepsArrayInfo = this.appState.get('DailyStepsData');
    this.chaptersInfo = this.currentPath.kyperChapters;
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.atWorkTime = false;
    this.morningTime = false;
    this.lunchTime = false;
    this.homeTime = false;
    this.bedTime = false;
    this.pathRegistration = this.appState.get("pathRegistration");
    if (
      this.currentUser?.imageUrl?.endsWith("avatar.png") ||
      this.currentUser?.imageUrl === "nil"
    ) {
      this.label = "Tap to Add Photo";
      this.isPhotoUploaded = false;
    } else {
      this.isPhotoUploaded = true;
    }
    if (!this.currentPath?.enabledAttributes?.chapter_skip) {
      this.fetchChaptersSteps();
    } else {
      this.rebuildPersonalizationLists();
    }
  }

  inputFocus() {
    this.isShowed = true;
    this.fileInput?.nativeElement?.click();
  }
  changePhoto() {
    if (this.isMobile && !this.platform.is("android") && !this.platform.is("mobileweb")) {
      this.chooseUploadOption();
    } else {
      this.inputFocus();
    }
  }

  ngAfterViewInit() {
    this.changeSubTextFont();
    this.resizeHeight();
    this.restoreResizeHeight();
    // Clear initial load flag after first paint so chapter-row-item
    // animation only runs on toggle interactions, not on landing
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.ngZone.run(() => { this.isInitialLoad = false; });
      });
    });
    if (
      this.isNotificationSettingsCalenderScreen ||
      this.isDaypartConfirmationScreen
    ) {
      this.initCalendarButton();
    }
    if (this.pathRegistration && this.pathRegistration.pathData) {
      if (
        !this.pathRegistration.pathData.emailReminderEnabled &&
        this.pathRegistration.pathData.emailReminderEnabled !== null
      ) {
        this.emailReminderEnabled =
          this.pathRegistration.pathData.emailReminderEnabled;
      }
      if (
        !this.pathRegistration.pathData.pushReminderEnabled &&
        this.pathRegistration.pathData.pushReminderEnabled !== null
      ) {
        this.pushReminderEnabled =
          this.pathRegistration.pathData.pushReminderEnabled;
      }
      if (
        this.pathRegistration.pathData.loginReminderEnabled &&
        this.pathRegistration.pathData.loginReminderEnabled !== null
      ) {
        this.pushNotificationsEnabled =
          this.pathRegistration.pathData.loginReminderEnabled;
      }
    }
  }

  async openPopup(chapterInfo) {
    if (this.dragOccurred) {
      this.dragOccurred = false;
      return;
    }
    const modal = await this.modalCtrl.create({
    component: ChapterStepsModalComponent,
      componentProps: { chapterStepsInfo: chapterInfo },
      animated: false,
      cssClass: this.isMobile?'custom-chapter-steps-modal-size':'web-action-calender-modal web-chapter-step-modal'

    })
    await modal.present();
  }

  handleReorder(event) {
    this.dragOccurred = true;
    if (this.currentPath?.enabledAttributes?.chapter_skip) {
      this.checkedChapters = event.detail.complete(this.checkedChapters);
      this.finalSortedChaptersInfo = [...this.checkedChapters, ...this.uncheckedChapters];
      this.finalizedChapterIds = this.finalSortedChaptersInfo?.map(c => c?.id);
      this.appState.set('tempReorderedChapterIds', this.finalizedChapterIds);
      this.syncToggleNumbers();
      this.cachePendingOrderInput();
      return;
    }
    const chaptersList = this.finalSortedChaptersInfo;
    const itemMove = chaptersList.splice(event.detail.from, 1)[0];
    chaptersList.splice(event.detail.to, 0, itemMove);
    this.finalizedChapterIds = chaptersList.map(c => c.id);
    this.finalSortedChaptersInfo = chaptersList;
    this.appState.set('tempReorderedChapterIds', this.finalizedChapterIds);
    event.detail.complete();
     this.cachePendingOrderInput();
  }

  private cachePendingOrderInput() {
    if (this.appState.get('chaptersOrderSavedFlag')) return;
    this.appState.set('pendingChaptersOrderInput', this.buildChaptersOrderInput(false));
  }

  syncChapterLists() {
    this.checkedChapters = this.finalSortedChaptersInfo.filter(c => !this.isChapterDeselected(c));
    this.uncheckedChapters = this.finalSortedChaptersInfo.filter(c => this.isChapterDeselected(c));
  }

  syncToggleNumbers() {
    setTimeout(() => {
      this.toggleIndexEls?.forEach((el, idx) => {
        el.nativeElement.innerText = idx + 1;
      });
    }, 10); // small delay to wait for DOM update
  }

  getCheckedChapterIds($event: any, chapter: any, index: number) {
    const isChecked = $event.detail.checked;
    this.isReorderDisabled.add(chapter.id);

    const isLastChecked = isChecked === false && this.checkedChapters.length === 1;
    const isFirstSelect  = isChecked === true  && this.checkedChapters.length === 0;

    this.ngZone.runOutsideAngular(() => {

      // CASE 1: deselecting the very last checked chapter
      if (isLastChecked) {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.isTransitioning = true;
            this.deselectedChapterIds = [...this.deselectedChapterIds, chapter.id];
            this.checkedChapters = [];
            this.uncheckedChapters = [chapter, ...this.uncheckedChapters];
            this.finalSortedChaptersInfo = [...this.uncheckedChapters] as any[];
            this.finalizedChapterIds = this.finalSortedChaptersInfo?.map(c => c?.id);
            this.appState.set('tempReorderedChapterIds', this.finalizedChapterIds);
          });
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.ngZone.run(() => { this.animatingChapterIds.add(chapter.id); });
              setTimeout(() => {
                this.ngZone.run(() => {
                  this.animatingChapterIds.delete(chapter.id);
                  this.isTransitioning = false;
                  this.isReorderDisabled.delete(chapter.id);
                  this.syncToggleNumbers();
                  this.cachePendingOrderInput();
                });
              }, 420);
            });
          });
        }, 300);
        return;
      }

      // CASE 2: selecting when checked list is empty
      if (isFirstSelect) {
        this.ngZone.run(() => { this.isTransitioning = true; });
        setTimeout(() => {
          this.ngZone.run(() => {
            this.deselectedChapterIds = this.deselectedChapterIds.filter(id => id !== chapter.id);
            this.uncheckedChapters    = this.uncheckedChapters.filter(c => c.id !== chapter.id);
            this.checkedChapters      = [chapter];
            this.finalSortedChaptersInfo = [...this.checkedChapters, ...this.uncheckedChapters] as any[];
            this.finalizedChapterIds = this.finalSortedChaptersInfo?.map(c => c?.id);
            this.appState.set('tempReorderedChapterIds', this.finalizedChapterIds);
            this.isTransitioning = false;
          });
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.ngZone.run(() => { this.animatingChapterIds.add(chapter.id); });
              setTimeout(() => {
                this.ngZone.run(() => {
                  this.animatingChapterIds.delete(chapter.id);
                  this.isReorderDisabled.delete(chapter.id);
                  this.syncToggleNumbers();
                  this.cachePendingOrderInput();
                });
              }, 420);
            });
          });
        }, 300);
        return;
      }

      // NORMAL CASE: moving between lists when both have items
      const delay = isChecked === false ? 300 : 250;
      setTimeout(() => {
        this.ngZone.run(() => {
          if (isChecked === false) {
            this.deselectedChapterIds = [...this.deselectedChapterIds, chapter.id];
            this.checkedChapters   = this.checkedChapters.filter(c => c.id !== chapter.id);
            this.uncheckedChapters = [chapter, ...this.uncheckedChapters];
          } else {
            this.deselectedChapterIds = this.deselectedChapterIds.filter(id => id !== chapter.id);
            this.uncheckedChapters    = this.uncheckedChapters.filter(c => c.id !== chapter.id);
            this.checkedChapters      = [...this.checkedChapters, chapter];
          }
          this.finalSortedChaptersInfo = [...this.checkedChapters, ...this.uncheckedChapters] as any[];
          this.finalizedChapterIds = this.finalSortedChaptersInfo?.map(c => c?.id);
          this.appState.set('tempReorderedChapterIds', this.finalizedChapterIds);
        });
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.ngZone.run(() => { this.animatingChapterIds.add(chapter.id); });
            setTimeout(() => {
              this.ngZone.run(() => {
                this.animatingChapterIds.delete(chapter.id);
                this.isReorderDisabled.delete(chapter.id);
                this.syncToggleNumbers();
                this.cachePendingOrderInput();
              });
            }, 420);
          });
        });
      }, delay);
    });
  }

  trackByChapterId(index: number, chapter: any): number {
    return chapter?.id;
  }

  isChapterDeselected(chapter: any): boolean {
    return this.deselectedChapterIds.includes(chapter.id);
  }

  private buildChaptersOrderInput(isFinalised: boolean): any {
    let reviewCount = 0;
    const excludedChaptersInfo = this.chaptersInfo.filter(chapter =>
      chapter.steps?.some(step =>
        step.position <= this.pathPersonalizationData?.step
      )
    );
    const excludedChapterIds = excludedChaptersInfo?.map(c => c?.id);
    if (excludedChaptersInfo?.length > 0) {
      const includedSteps = this.chaptersInfo[0].steps;
      reviewCount = includedSteps.filter(s => s.stepStatus === 'Review')?.length;
    }

    if (this.currentPath?.enabledAttributes?.chapter_skip) {
      const selectedChapters = (this.checkedChapters as any[])
        .filter(c => !excludedChapterIds.includes(c.id));
      const deselectedChapters = (this.uncheckedChapters as any[])
        .filter(c => !excludedChapterIds.includes(c.id));
      const orderedChapters = [...excludedChaptersInfo, ...selectedChapters, ...deselectedChapters] as any[];
      const chapterOrderIds = orderedChapters.map(c => c.id);
      const finalSelectedOrderIds = [...excludedChaptersInfo, ...selectedChapters].map(c => c.id);
      return {
        chapter_id: excludedChaptersInfo?.length > 0 ? excludedChaptersInfo[0].id : 0,
        chapter_order: chapterOrderIds,
        is_finalised: isFinalised,
        steps_completed_in_chapter: reviewCount > 0 ? reviewCount : this.pathPersonalizationData?.step - 1,
        selected_chapter_ids: finalSelectedOrderIds
      };
    }
    return {
      chapter_id: excludedChaptersInfo?.length > 0 ? excludedChaptersInfo[0].id : 0,
      chapter_order: this.finalizedChapterIds?.length > 0
        ? [...excludedChapterIds, ...this.finalizedChapterIds]
        : [...excludedChapterIds, ...this.finalSortedChaptersInfo.map(c => c.id)],
      steps_completed_in_chapter: reviewCount > 0 ? reviewCount : this.pathPersonalizationData?.step - 1,
      is_finalised: isFinalised,
    };
  }

  openGeneratePopup() {
    const input = this.buildChaptersOrderInput(true);
    this.homeUiService.fetchChaptersInfo(input).subscribe((res) => {
      this.generatePopup = true;
      this.showSuccessAlert();

      if (!this.currentPath?.enabledAttributes?.chapter_skip) {
        // Legacy: original simple handler — store and let the next mount rebuild.
        const shuffledOj = {
          chapterOrder: res?.data?.chapter_order,
          id: res?.data?.chapter_id,
          stepsCompletedInChapter: res?.data?.step_completed_in_chapter,
          isFinalised: res?.data?.is_finalised??res?.data?.isFinalised
        };
        console.log("user shuffled chapters", res);
        this.userShuffledChapters = shuffledOj;
        this.appState.set('isPathPersonalized', true);
        mixpanel.track("Set the user shuffled order of chapters", { shuffledOrder: shuffledOj, res: res });
        this.appState.set('userShuffledChapters', shuffledOj);
        this.appState.set('tempReorderedChapterIds', null);
        this.appState.set('chaptersOrderSavedFlag', true);
        this.appState.set('pendingChaptersOrderInput', null);
        this.sortChaptersAndUpdateSteps(res?.data?.chapter_order, this.currentPath?.kyperChapters);
        return;
      }

      // New mode: split currentPath into kyperChapters (selected) / deselectedChapters,
      // then rebuild the toggle UI from the new state.
      const data = res?.data ?? {};
      const allOrder: number[] = data?.chapter_order ?? data?.chapterOrder;
      const selectedIds: number[] = data?.selected_chapter_ids ?? data?.selectedChapterIds
      const shuffledOj: any = {
        chapterOrder: allOrder,
        id: data?.chapter_id??data?.chapterId,
        stepsCompletedInChapter: data?.steps_completed_in_chapter ?? data?.stepsCompletedInChapter ?? 0,
        selectedChapterIds: selectedIds,
        isFinalised: data?.is_finalised??data?.isFinalised
      }

      // Update userShuffledChapters BEFORE calling sortChaptersAndUpdateSteps
      this.userShuffledChapters = shuffledOj;

      const allChaptersUnion: any[] = [
        ...(this.currentPath?.kyperChapters ?? []),
        ...(this.currentPath?.deselectedChapters ?? [])
      ];
      const deselectedList = allChaptersUnion.filter(c => !selectedIds.includes(c.id));
      if (this.currentPath) {
        this.currentPath.userChapter = shuffledOj;
        this.currentPath.deselectedChapters = deselectedList;
        this.appState.set('currentPath', this.currentPath);
      }
      this.deselectedChapterIds = deselectedList.map(c => c.id);

      // Now call sortChaptersAndUpdateSteps after userShuffledChapters is set
      this.sortChaptersAndUpdateSteps(res?.data?.chapter_order??res?.data?.chapterOrder, this.currentPath?.kyperChapters);

      console.log("user shuffled chapters", res);
      this.appState.set('isPathPersonalized', true);
      mixpanel.track("Set the user shuffled order of chapters", { shuffledOrder: shuffledOj, res: res })
      this.appState.set('userShuffledChapters', shuffledOj);
      this.appState.set('deselectedChapters', deselectedList);
      this.appState.set('tempReorderedChapterIds', null);

      this.rebuildPersonalizationLists();
      this.syncToggleNumbers();
      this.appState.set('chaptersOrderSavedFlag', true);
      this.appState.set('pendingChaptersOrderInput', null);
    }, (err) => {
      mixpanel.track("Error while saving chapters order in path personalization ", { 'InputParams': input })
      this.generatePopup = false 
      // this.fetchChaptersSteps()
      this.toastrService.error(this.i18n.t('Something went wrong while saving cycle personalization data. Please try again later.'))
    })
  }
  async showSuccessAlert() {
    const alert = await this.alertController.create({
      message: `<div class="alert-header-content m-0 p-0">
        <img src="assets/images/Right-tick.png" class="alert-icon" />
       <h3 class="generate-heading"> ${this.i18n.t('Success!')}</h3>
        <ion-text class="generate-sub-text">${this.i18n.t('You’ll see your personalized cycle when you get back to the Home Screen')}</ion-text>
      </div>`,
      cssClass: 'generate-popup',
      buttons: [{
        text: this.i18n.t('Got it!'),
        role: 'confirm',
        cssClass: 'generate-btn',
        handler: () => {
          this.generatePopup = false;
        }
      }]
    });

    await alert.present();
  }

  sortChaptersAndUpdateSteps(chapterOrder: string[], chapters: any[]) {
    const sortedChapters = [...chapters].sort((a, b) => {
      return chapterOrder.indexOf(a.id) - chapterOrder.indexOf(b.id);
    });
    console.log("sorted chapters", sortedChapters);

    let index = 1;
    sortedChapters?.forEach((chapter, i) => {
      chapter.position = i;
      const chapterSteps = chapter?.steps;
      chapterSteps?.forEach(step => {
        step.position = index;
        index++;
      });
    });

    this.dailyStepsArrayInfo = sortedChapters;
    this.appState.set('DailyStepsData', this.dailyStepsArrayInfo);
    // this.finalSortedChaptersInfo = sortedChapters;

    // Legacy mode: use all chapters in sorted order
    if (!this.currentPath?.enabledAttributes?.chapter_skip) {
      if (this.currentPath) {
        this.currentPath.kyperChapters = sortedChapters;
        this.appState.set('currentPath', this.currentPath);
      }
      return;
    }

    // New mode: split by selectedIds
    const selectedIds = this.userShuffledChapters?.selectedChapterIds ?? [];
    this.checkedChapters = sortedChapters.filter(c => selectedIds.includes(c.id));
    this.uncheckedChapters = sortedChapters.filter(c => !selectedIds.includes(c.id));

    if (this.currentPath) {
      this.currentPath.kyperChapters = this.checkedChapters;
      this.currentPath.deselectedChapters = this.uncheckedChapters;
      this.appState.set('currentPath', this.currentPath);
    }
  }
  resizeHeight(){
    this.keyboard.onKeyboardDidShow().subscribe((info) => {
       const mobileLoginScreens = document.querySelectorAll('.card.reflection-min-height');
          mobileLoginScreens.forEach((screen) => {
            if(this.platform.is('android')) {
              screen.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px - 50px);  min-height: unset`);
            }
            if(this.platform.is('ios')) {
              screen.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px);  min-height: unset`);  
            }
            setTimeout(() => {
              screen.scrollTop = screen.scrollHeight;
            }, 100);

          });
          console.log('keyboard show');
       });
  }

  restoreResizeHeight(){
    this.keyboard.onKeyboardDidHide().subscribe(() => {
      const mobileLoginScreens = document.querySelectorAll('.card.reflection-min-height');
      mobileLoginScreens.forEach((screen) => {
          screen.setAttribute('style', `height: unset; min-height: 530px`);
      });
      console.log('keyboard hide');
    })
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // scrollToInput(input: HTMLElement) {
  //   const inputPosition = input.getBoundingClientRect().top + window.scrollY; 
  //   const desiredPosition = inputPosition - 100; 
  //   const container = document.querySelector('.mobile-login-screen') as HTMLElement; 
  //   container.scrollTo({
  //       top: desiredPosition,
  //       behavior: 'smooth'
  //   });
  // }

  selectTime(option) {
    if (this.confirmedTime) {
      return;
    }
    let time = "";
    switch (option) {
      case "AFTER_WAKING_UP":
        time = "07:00";
        this.morningTime = true;
        this.atWorkTime = false;
        this.lunchTime = false;
        this.homeTime = false;
        this.bedTime = false;
        this.itemPublish = 14;
        break;
      case "AFTER_ARRIVING_AT_WORK":
        time = "09:00";
        this.atWorkTime = true;
        this.morningTime = false;
        this.lunchTime = false;
        this.homeTime = false;
        this.bedTime = false;
        this.itemPublish = 18;
        break;
      case "AFTER_LUNCH":
        time = "12:00";
        this.lunchTime = true;
        this.atWorkTime = false;
        this.morningTime = false;
        this.homeTime = false;
        this.bedTime = false;
        this.itemPublish = 24;
        break;
      case "AFTER_ARRIVING_HOME":
        time = "17:00";
        this.atWorkTime = false;
        this.morningTime = false;
        this.lunchTime = false;
        this.homeTime = true;
        this.bedTime = false;
        this.itemPublish = 34;
        break;
      case "BEFORE_BED":
        time = "22:00";
        this.atWorkTime = false;
        this.morningTime = false;
        this.lunchTime = false;
        this.homeTime = false;
        this.bedTime = true;
        this.itemPublish = 44;
        break;
      default:
        this.itemPublish = 22;
    }
    this.openPicker();
    this.selectedTimeOption = this.currIndex;
  }

  confirmTime() {
    this.confirmedTime = this.selectedTime;
    this.appState.set("learningTime", this.confirmedTime);
    localStorage.setItem("learningTime", this.confirmedTime);

    localStorage.setItem("notificationsEnabled", "true");
    localStorage.setItem("emailReminderEnabled", "true");
    localStorage.setItem("socialReminderEnabled", "true");
    localStorage.setItem("socialEmailReminder", "true");
    this.resetCalenderData = false;
    this.initCalendarButton(); // LUMBA-1421
    this.NotificationConfirmationModal();
    this.checkScreenCompletion();
  }

  async NotificationConfirmationModal() {
    const modal = await this.modalCtrl.create({
      component: NotificationConfirmationPopupComponent,
      componentProps: { time: this.confirmedTime, day:this.selectedDayName },
      cssClass: this.isMobile
        ? "notification-reminder-popup-mobile"
        : "notification-reminder-popup-web",
    });
    await modal.present();
    modal.onDidDismiss().then((result) => {
      if (result?.data?.enablePush) {
        this.getTokenAfterLogin();
        // if (this.cordovaService.isIOS() && typeof FCMPlugin !== "undefined") {
        //   FCMPlugin.requestPermissionOnIOS();
        //   this.permissionRequest();
        // // } else if (this.cordovaService.isIOS) {
        // //   this.notificationAlertBox();
        //  }
        this.requestNotificationPermission();
      } else {
        // this.pushNotificationsEnabled = false;
         let deviceId;
    if (this.isMobile && (localStorage.getItem('deviceToken') !== null || localStorage.getItem('deviceToken') != undefined)) {
      deviceId =localStorage.getItem('deviceToken')
    }
    else {
      deviceId = this.pathRegistration.pathData.deviceRegistrationId;
    }
        this.permissionRequest(deviceId);
      }
    });
  }
  async getTokenAfterLogin() {
    await this.platform
      .ready()
      .then(() => {
        this.firebaseX
          .getToken()
          .then((token) => {
            localStorage.setItem("deviceToken", token);
            console.log(`The token is ${token}`);
          })
          .catch((error) => console.error("Error getting token", error));

        this.firebaseX.onTokenRefresh().subscribe((token: string) => {
          localStorage.setItem("deviceToken", token);
          console.log("New device token : ", token);
        });
      })
      .catch((error) => {
        console.log("platform  error : ", error);
      });
  }

  unconfirmTime() {
    const previousTime = this.confirmedTime;
    this.confirmedTime = null;
  }
  checkScreenCompletion() {
    if (this.confirmedTime) {
      const time = moment(this.confirmedTime, "HH:mm");
      const timeString = time.format("HH:mm A");
      mixpanel.track("Onboarding-confirmTime", { confirmTime: timeString });
    }
  }
  initCalendarButton() {
    this.isWeeklyEnabled = this.currentPath?.enabledAttributes?.reminder_type=="weekly" ?true: false;
    this.prepareCalendarParams();
    if (this.hasNativeCalendar) {
      return;
    }
    const calendarButtons = AddToCalendar.addToCalendar({
      options: {
        class: "mtr-btn",
        id: "add-calendar-buttons-id",
        label: this.i18n.t("Add to your calendar")
      },
      data: {
        title: this.calendarParams.title,
        start: this.calendarParams.startDate,
        // timezone: America/Los_Angeles,					// converts the time to the IANA timezone
        end: this.calendarParams.endDate,
        // duration: 120,                            // Event duration (IN MINUTES)
        //allday: true,													// Override end time, duration and timezone, triggers 'all day'
        address: this.calendarParams.eventLocation,
        description: this.calendarParams.notes,
        frequency: this.isWeeklyEnabled ? "WEEKLY" : "DAILY",
        endDate: this.endDate,
      },
    });
    const label = calendarButtons?.querySelector('.add-to-calendar-label') as HTMLElement;
    if (label) { label.textContent = this.i18n.t('Add to calendar'); }
    const parent = $(this.calendarButtonsContainer?.nativeElement);
    const w: any = window;
    w.closeCalenderOnMouseDown = this.cloudCalendarCollapser.bind(this);
    parent.empty();
    parent.append(calendarButtons);
    $("#checkbox-for-add-calendar-buttons-id").change(
      (event) => (this.cloudCalendarExpanded = event.target.checked)
    );
  }

  cloudCalendarCollapser() {
    const doCollapseCloudCalendar = () => {
      setTimeout(() => {
        $("#checkbox-for-add-calendar-buttons-id")[0].checked = false;
      }, 150);
      this.cloudCalendarExpanded = false;
      this.cloudCalendarSet = true;
      document.removeEventListener("mousedown", doCollapseCloudCalendar);
    };
    document.addEventListener("mousedown", doCollapseCloudCalendar);
  }
  getButtonIndex(index, type) {
    switch (index) {
      case 0:
        this.defaultTime = "07:00";
        break;
      case 1:
        this.defaultTime = "09:00";
        break;
      case 2:
        this.defaultTime = "12:00";
        break;
      case 3:
        this.defaultTime = "17:00";
        break;
      case 4:
        this.defaultTime = "22:00";
        break;
      default:
        this.defaultTime = "22:00";
    }
    this.currIndex = index;
    this.selectedDayPartType = type?.title;
    // this.pathRegistration.selectedDayPart = this.selectedDayPartType;
  }
  prepareCalendarParams(routinelen: any = null) {
    this.pathRegistration = this.appState.get("pathRegistration");
    this.isWeeklyEnabled = this.currentPath?.enabledAttributes?.reminder_type=="weekly" ?true: false;
    this.selectedDate = this.selectedDate ? this.selectedDate : this.pathRegistration?.pathData?.loginReminderDate;
    this.confirmedTime = this.confirmedTime ? this.confirmedTime : this.pathRegistration?.pathData?.loginReminderTime;
    const daysCount = this.isWeeklyEnabled ? this.currentPath.lastDayOfContent()  : this.currentPath.lastDayOfContent() * 1.5;
    if (!this.confirmedTime && this.confirmedTime == null) {
      this.start = this.isWeeklyEnabled && this.selectedDate && this.confirmedTime ?  moment(`${this.selectedDate} ${this.confirmedTime}`, "DD-MM-YYYY HH:mm") : moment(new Date(), "HH:mm");
      this.end = this.isWeeklyEnabled && this.selectedDate && this.confirmedTime? moment(`${this.selectedDate} ${this.confirmedTime}`,"DD-MM-YYYY HH:mm").add(10, "minute") : moment(new Date(), "HH:mm").add(10, "minute");
      this.endDate = this.isWeeklyEnabled && this.selectedDate && this.confirmedTime?  moment(`${this.selectedDate} ${this.confirmedTime}`, "DD-MM-YYYY HH:mm").add(daysCount, "week").toDate() : moment(new Date(), "HH:mm").add(daysCount, "day").toDate();
    } else {
      this.start = this.isWeeklyEnabled && this.selectedDate && this.confirmedTime ?  moment(`${this.selectedDate} ${this.confirmedTime}`, "DD-MM-YYYY HH:mm") :moment(this.confirmedTime, "HH:mm");
      this.end = this.isWeeklyEnabled && this.selectedDate && this.confirmedTime? moment(`${this.selectedDate} ${this.confirmedTime}`, "DD-MM-YYYY HH:mm").add(10, "minute") :moment(this.confirmedTime, "HH:mm").add(10, "minute");
      this.endDate = this.isWeeklyEnabled && this.selectedDate && this.confirmedTime ?  moment(`${this.selectedDate} ${this.confirmedTime}`, "DD-MM-YYYY HH:mm").add(daysCount, "week").toDate() : moment(this.confirmedTime, "HH:mm")
        .add(daysCount, "day")
        .toDate();
    }

    var titleOfEvent = "Daily Learning Reminder";

    try {
      if (this.currentPath.names && this.currentPath.names.titleOfEvent) {
        titleOfEvent = this.currentPath.names.titleOfEvent;
      } else {
        titleOfEvent = this.isWeeklyEnabled? this.i18n.t("Weekly Learning Reminder"): this.i18n.t("Daily Learning Reminder");
      }
    } catch (error) {}

    this.calendarParams = {
      startDate: this.start.toDate(),
      endDate: this.end.toDate(),
      title: titleOfEvent,
      eventLocation: "",
      notes: this.calendarCopy.nextStepNotes(),
      endEventTime: null,
      frequency: this.isWeeklyEnabled? "WEEKLY": "DAILY",
    };
  }
  async openPicker(
    time?,
    numColumns = 1,
    numOptions = 49,
    columnOptions = defaultColumnOptions
  ) {
    this.isWeeklyEnabled = this.currentPath?.enabledAttributes?.reminder_type=="weekly" ?true: false;
    let defaultHour = parseInt(this.defaultTime.split(":")[0]);
    if (time) {
      defaultHour = parseInt(time.split(":")[0]);
    }
    const defaultMinute = parseInt(
      this.defaultTime.split(":")[1].split(" ")[0]
    );
    let defaultAmPm = this.defaultTime.split(" ")[1];
    defaultAmPm = defaultHour < 12 ? "AM" : "PM";

    if (defaultHour === 0) {
      defaultHour = 12;
    } else if (defaultHour > 12) {
      defaultHour -= 12;
      defaultAmPm = "PM";
    }
    const picker = await this.pickerController.create({
      columns: [
         ...(this.isWeeklyEnabled ? [{ name: "day", options: this.generateDayOptions(), selectedIndex: 0 }] : []),
        {
          name: "hour",
          options: this.generateHourOptions(), // For hours in 12-hour format
          selectedIndex: defaultHour - 1,
        },
        {
          name: "minute",
          options: this.generateColumnOptions(), // For minutes
          selectedIndex: defaultMinute === 0 ? 0 : 1,
        },
        {
          name: "ampm",
          options: [
            { text: "AM", value: "AM" },
            { text: "PM", value: "PM" },
          ],
          selectedIndex: defaultAmPm === "AM" ? 0 : 1,
        },
      ],
      buttons: [
        {
          text: this.i18n.t("Cancel"),
          role: "cancel",
        },
        {
          text: this.i18n.t("Confirm"),
          handler: (value) => {
            console.log("Selected time:", value);
            this.afterWakingUp(value);
          },
        },
      ],
      cssClass: `${this.homeUiService.isDark() ? "dark-theme" : "light-theme"}`,
    });

    await picker.present();
  }
  afterWakingUp(time) {
    let time12h =
      time.hour.text + ":" + time.minute.text + " " + time.ampm.text;
    const [tim, modifier] = time12h.split(" ");
    let [hours, minutes] = tim.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      let i = parseInt(hours, 10) + 12;
      hours = i.toString();
    }
    this.selectedTime = hours + ":" + minutes;
    if (this.isWeeklyEnabled) {
      this.selectedDay = time?.day?.value?.day;
      this.selectedDayName = time?.day?.text; 
      this.selectedDate = time?.day?.value?.date;
      this.appState.set("selectedReminderDate", this.selectedDate);
    }

    console.log("this.selectedDay", this.selectedDay, this.selectedDate);  
    if (this.selectedTime != null) {
      this.getConfirmedTimeInNormalMode(this.selectedTime);
    }

    for (let index = 0; index < this.dailyRoutine.length; index++) {
      if (index == this.currIndex) {
        this.dailyRoutine[this.currIndex].time = this.selectedTime;
        localStorage.setItem("currIndex", index + "");
      } else {
        this.dailyRoutine[index].time = null;
      }
    }
    this.confirmTime();
  }
  getConfirmedTimeInNormalMode(optedTime) {
    let time = optedTime?.split(":")[0];
    let time1 = optedTime?.split(":")[1];
    time = parseInt(time);
    time1 = parseInt(time1);
    if (time1 == 0) {
      time1 = "00";
    }
    if (time > 12) {
      this.confirmationCalendartime = time - 12 + ":" + time1 + " " + "PM";
    } else if (time == 12 && time1 == 0) {
      this.confirmationCalendartime = time + ":" + "00" + " " + "PM";
    } else if (time == 12 && time1 == 30) {
      this.confirmationCalendartime = time + ":" + time1 + " " + "PM";
    } else {
      this.confirmationCalendartime = time + ":" + time1 + " " + "AM";
    }
  }
  generateHourOptions() {
    const options = [];
    for (let i = 1; i <= 12; i++) {
      options.push({
        text: i.toString(),
        value: i.toString().padStart(2, "0"),
      });
    }
    return options;
  }
  generateColumnOptions() {
    const options = [
      { text: "00", value: "00" },
      { text: "30", value: "30" },
    ];
    return options;
  }

  generateDayOptions() {
    const dayNames = [
     this.i18n.t("Sunday"),
      this.i18n.t("Monday"),
      this.i18n.t("Tuesday"),
      this.i18n.t("Wednesday"),
      this.i18n.t("Thursday"),
      this.i18n.t("Friday"),
      this.i18n.t("Saturday"),
    ];

    const today = new Date();
    const todayIndex = today.getDay(); // 0 = Sunday, 1 = Monday, etc.

    const options = [];

    for (let i = 0; i < 7; i++) {
      const nextDate = new Date();
      nextDate.setDate(today.getDate() + i);

      const dayIndex = (todayIndex + i) % 7;
      // const upcomingDate =nextDate.toISOString().split("T")[0]; // YYYY-MM-DD format
   const year = nextDate.getFullYear();
    const month = (nextDate.getMonth() + 1).toString().padStart(2, '0'); // Add 1 and pad with '0' if single digit
    const day = nextDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${day}-${month}-${year}`;
      options.push({
        text: dayNames[dayIndex],
        value: {
          day: dayIndex,
          date: formattedDate
        },
      });
    }

    return options;
  }
  toggle() {
    if (this.pushNotificationsEnabled && this.cordovaService.isIOS) {
      // this.notificationAlertBox();
      this.requestNotificationPermission();
    }
     let deviceId;
     if (
       this.isMobile &&
       (localStorage.getItem("deviceToken") != null ||
         localStorage.getItem("deviceToken") != undefined)
     ) {
       deviceId = localStorage.getItem("deviceToken");
     } else {
       deviceId = this.pathRegistration.pathData.deviceRegistrationId;
     }
    this.permissionRequest(deviceId);
  }
  notificationAlertBox() {
    let dialogRef = this.dialog.open(AlertNotifyComponent);
    dialogRef.afterClosed().subscribe((result) => {
      // if (result === "confirm" || result == undefined) {
      //   this.pushNotificationsEnabled = true;
      //   this.permissionRequest();
      // }
    });
  }

  async requestNotificationPermission() {
    const permissionStatus = await this.firebaseX.hasPermission();
    if (this.platform.is("ios") || this.platform.is("android")) {
      this.platform.ready().then(() => {
        if (permissionStatus) {
          console.log("Notification permission is already granted");
          // Further actions when permission is already granted
        } else if (permissionStatus == false) {
          
          //this.showPermissionPopup();
          this.getToken();
        }
      });
    }
  }

  permissionRequest(deviceToken: any = null) {
    let savedPathRegistration = this.appState.get("pathRegistration");
     this.pathRegistration = this.appState.get("pathRegistration");
    let currentDay = this.appState.get("currentScheduleDay");
    const pathRegistration = {
         selected_day_part: this.selectedDayPartType ? this.selectedDayPartType : savedPathRegistration?.selectedDayPart,
      // schedule_day: 1,
      path_data: {
        email_reminder_enabled: this.emailReminderEnabled == false ? false : true,
        login_reminder_time: this.confirmedTime,
        login_reminder_enabled: this.pushNotificationsEnabled == false ? false : true,
        device_registration_id: deviceToken,
        push_reminder_enabled: true,
        social_reminder_enabled:
          savedPathRegistration.pathData.socialReminderEnabled == false
            ? false
            : true,
        social_email_enabled:
          savedPathRegistration.pathData.socialEmailEnabled == false
            ? false
            : true,
        selected_learning_day: savedPathRegistration?.pathData?.selectedLearningDay ? savedPathRegistration?.pathData?.selectedLearningDay : ((!this.selectedDayPartType && !savedPathRegistration?.selectedDayPart) ? null : currentDay),
        login_reminder_weekday: this.selectedDay ?? savedPathRegistration.pathData?.loginReminderWeekday ,
        login_reminder_date: this.selectedDate ?? savedPathRegistration.pathData?.loginReminderDate
      }
    }

    //   new PathRegistration({
    //   userId: this.currentUser.id,
    //   pathId: this.currentPath.id,
    //   pathData: {
    //     loginReminderEnabled:
    //       this.pushNotificationsEnabled == false ? false : true,
    //     loginReminderTime: this.confirmedTime,
    //     deviceRegistrationId: deviceToken,
    //     emailReminderEnabled: this.emailReminderEnabled == false ? false : true,
    //     pushReminderEnabled: true,
    //     socialReminderEnabled:
    //       savedPathRegistration.pathData.socialReminderEnabled == false
    //         ? false
    //         : true,
    //     socialEmailEnabled:
    //       savedPathRegistration.pathData.socialEmailEnabled == false
    //         ? false
    //         : true,
    //     selectedLearningDay: savedPathRegistration?.pathData?.selectedLearningDay ? savedPathRegistration?.pathData?.selectedLearningDay : ((!this.selectedDayPartType && !savedPathRegistration?.selectedDayPart) ? null : currentDay),
    //     loginReminderWeekday: this.selectedDay ?? savedPathRegistration.pathData?.loginReminderWeekday ,
    //     loginReminderDate: this.selectedDate ?? savedPathRegistration.pathData?.loginReminderDate
    //   },
    //   // scheduleDay: (savedPathRegistration?.scheduleDay && (!this.selectedDayPartType || !savedPathRegistration?.selectedDayPart) ? null : currentDay),
    //   selectedDayPart: this.selectedDayPartType ? this.selectedDayPartType : savedPathRegistration?.selectedDayPart,
    // });
    if (!savedPathRegistration?.selectedLearningDay && (this.selectedDayPartType && savedPathRegistration?.selectedDayPart == null ) ) {
      // pathRegistration.schedule_day = currentDay;
      pathRegistration['screen_content_id'] = this.learningScreenData?.screenContentId;
      pathRegistration['step_id'] = this.learningScreenData?.stepId;
    }

    

    this.kyperApiService.kyperUpdatePathRegistration(pathRegistration).subscribe(
      (response) => {
        this.updatePathRegistration = response.data;
        this.appState.set(
          "pathRegistration",
          this.updatePathRegistration
        );
        this.pathRegistration = this.appState.get("pathRegistration");
        this.confirmedTime = this.pathRegistration?.pathData?.loginReminderTime
        this.selectedTime = this.pathRegistration?.pathData?.loginReminderTime
        this.selectedDate = this.pathRegistration?.pathData?.loginReminderDate
        // Persist screen completion on the SERVER (same updateContentScreenCompletion endpoint the
        // manager/accountability screens use) once the user has actually saved THIS screen's data.
        // The notification flow has TWO screens: the learning-time / daypart-selection screen saves
        // the reminder TIME, while the confirmation/calendar screen saves the learning-reminder
        // toggle. The Next gate is now sticky (reads screen.isCompleted), so completion must reflect a
        // GENUINELY valid state: the time screen completes when a reminder time is stored; the
        // confirmation/calendar screen completes ONLY when a reminder time AND the learning-reminder
        // toggle are both on. This keeps a toggle-OFF save from sticking completion (so Next disables
        // as the user asked) and — because completion always requires a time — can never reintroduce
        // the null-time "Next active" bug. NOTE: loginReminderEnabled IS the learning-reminder toggle;
        // pushReminderEnabled is deliberately ignored (the payload hardcodes it true, so it would make
        // "method selected" always-true). markScreenCompleted skips a redundant POST when completed.
        const notifPathData: any = this.pathRegistration?.pathData;
        const savedTime = !!notifPathData?.loginReminderTime;
        const savedMethod = !!notifPathData?.loginReminderEnabled || !!notifPathData?.emailReminderEnabled ;
        const savedThisScreen = this.isDaypartSelectionScreen ? savedTime : ( savedMethod);

        if (savedThisScreen) {
          this.homeUiService.markScreenCompleted(
            this.learningScreenData?.stepId,
            this.learningScreenData?.screenId,
            this.learningScreenData?.screenContentId,
            this.learningScreenData
          );
        }
      },
      (error) => {
        console.log("Server push Notifi error", error);
        this.toastrService.error(
          this.i18n.t(
            "Server or connection issue. Please check your internet connection."
          )
        );
      },
      () => {}
    );

    this.analyticsService.setOnboardingEvent(
      "innstep-Onboarding",
      "Notification button enabled",
      this.currentScreenId,
      this.currentPath.id,
      this.currentClient.id
    );
  }
  loadprocessedCommitmentNotifications() {
    const storedData = localStorage.getItem('processedCommitmentNotifications');
    if (storedData) {
      this.processedCommitmentNotifications = new Set(JSON.parse(storedData));
    }
  }
  loadprocessedCommunityNotifications() {
    const storedData = localStorage.getItem('processedCommunityNotifications');
    if (storedData) {
      this.processedCommunityNotifications = new Set(JSON.parse(storedData));
    }
  }
  async getToken() {
    let deviceToken;
    if (this.platform.is("ios") || this.platform.is("android")) {
      this.platform
        .ready()
        .then(async () => {
          await this.firebaseX.hasPermission().then(
            async (res) => {
              await this.firebaseX.grantPermission().then((permission) => {
                console.log("ios permission : ", permission);
                if (!permission && this.cordovaService.isIOS) {
                  this.notificationAlertBox();
                }
              });

              this.firebaseX
                .getToken()
                .then((token) => {
                  deviceToken = token;
                  localStorage.setItem("deviceToken", token);
                  this.permissionRequest(deviceToken);
                })
                .catch((error) => console.error("Error getting token", error));

              this.firebaseX.onMessageReceived().subscribe((data) => {
                let postData = JSON.parse(data?.keysandvalues)
                  console.log('data outside platform.resume() notifications from onboading learning component:', data);
                let notificationId = data['gcm.message_id']?parseInt(data['gcm.message_id']):parseInt(data['google.message_id']?.split(':')[1]?.split('%')[0])
                  console.log('Starting notification ID (onboarding leaarning component):', notificationId);
                const isForeground = data.tap === 'foreground' ||
                  ((postData['notification_foreground'] === true || data['notification_foreground'] === 'true') && !data.tap);
                const isTappedFromBg = !isForeground && !!data.tap;
                  const requestData = {
                  userId: postData.user_id,
                  mode: postData?.mode,
                  postId: postData?.post_id,
                  id: notificationId,
                  route: postData?.route,
                    body: data?.aps ? data?.aps?.alert?.body : data?.body,
                    title: data?.aps ? data?.aps?.alert?.title : data?.title,
                  pathId: postData?.path_id,
                  postData: JSON.parse(data?.keysandvalues),
                  notification_type: postData?.notification_type,
                    notificationSentTimestamp: data?.sent_at,
                   tap: data?.tap,
                  screenContentId: postData?.screenContentId,
                   receivedInForeground: isForeground
                };
                this.loadprocessedCommitmentNotifications();
                this.loadprocessedCommunityNotifications();
                 if (!this.isCommitmentNotificationProcessed(notificationId) && !this.processedCommunityNotifications?.has(notificationId)) {
                   mixpanel.track('Push notification received in onboardingLearningComponent', {
                     userId: postData.user_id,
                      body: data?.aps ? data?.aps?.alert?.body : data?.body,
                    title: data?.aps ? data?.aps?.alert?.title : data?.title,
                  pathId: postData?.path_id,
                     id: notificationId,
                     notification_type: postData?.notification_type,
                     postData: JSON.parse(data?.keysandvalues),
                     notificationSentTimestamp: data?.sent_at,
                     currentTimestamp: new Date().toISOString(),
                      tap: data?.tap,
                     screenContentId: postData?.screenContentId,
                   receivedInForeground: isForeground
                   });
                }
                this.appState.set('AfterAppInit', requestData)
                // "AfterAppInit" used for when app is not in BG

                  if (isTappedFromBg && !!this.appState.get('currentUser')) {
                     // Cases 1 & 2: User tapped notification banner while app was running in BG.
                     // Session is already active (currentUser set), so route directly.
                     // platform.resume fires before onMessageReceived in tap scenarios,
                     // so we route directly here instead of waiting for resume.
                     mixpanel.track('Banner tapped from BG - routing directly in onboarding learning notification screen', { id: notificationId, tap: data?.tap });
                     this.ngZone.run(() => {
                       setTimeout(() => {
                         this.handleNotificationRoute(postData, notificationId, requestData, data);
                       }, 500);
                     });
   
                   } else if (isTappedFromBg && !this.appState.get('currentUser')) {
                     // Case 3: App was killed. Session not loaded yet (currentUser is null).
                     // AfterAppInit is stored above; routeAfterNotification in session.service
                     // will handle routing after the session is fully initialized.
                     mixpanel.track('Banner tapped, app killed - waiting for session init in onboarding learning notification screen', { id: notificationId });
   
                   } else if (isForeground) {
                     // Case 4: Notification arrived while app was in foreground.
                     // Never redirect — not now, not after any BG/FG cycle.
                     // We intentionally skip setting up platform.resume so this is permanent.
                     mixpanel.track('FG notification received, no redirect in onboarding learning notification', { id: notificationId, tap: data?.tap });
   
                   } else {
                     // BG silent delivery — user will open the app manually later.
                     // Set up platform.resume to route at that point.
                     mixpanel.track('BG notification, waiting for resume in onboarding learning notification screen', { id: notificationId, tap: data?.tap });
                     this.platform.resume.pipe(takeUntil(this.destroyed$)).subscribe(() => {
                       mixpanel.track('Platform resume in onboarding learning notification Component');
                       this.loadprocessedCommitmentNotifications();
                       this.loadprocessedCommunityNotifications();
                       let communitySavedId = parseInt(localStorage.getItem('CommunityNotificationId'))
                       let commitmentsSavedId = parseInt(localStorage.getItem('CommitmentsNotificationId'))
                       this.handleNotificationRoute(postData, notificationId, requestData, data);
                     });
                   }            
                  this.sessionService.removeNotificationBadge()

                },
                  (error) => {
                   console.log('error notifications:', error);
              });
            },
            (error) => {
              console.log("permission error :", error);
            }
          );

          this.firebaseX.onTokenRefresh().subscribe((token: string) => {
            deviceToken = token;
            this.permissionRequest(deviceToken);
            localStorage.setItem("deviceToken", token);
          });
        })
        .catch((error) => {
          console.log("platform  error : ", error);
        });
    } else {
       let deviceId;
    if (this.isMobile && (localStorage.getItem('deviceToken') !== null || localStorage.getItem('deviceToken') != undefined)) {
      deviceId =localStorage.getItem('deviceToken')
    }
    else {
      deviceId = this.pathRegistration.pathData.deviceRegistrationId;
    }
      this.permissionRequest(deviceId);
    }
  }

 private handleNotificationRoute(postData, notificationId, requestData, data) {
    this.loadprocessedCommitmentNotifications();
    this.loadprocessedCommunityNotifications();
    const notificationData = {
      userId: postData.user_id,
      body: data?.aps ? data?.aps?.alert?.body : data?.body,
      title: data?.aps ? data?.aps?.alert?.title : data?.title,
      pathId: postData?.path_id,
      id: notificationId,
      notification_type: postData?.notification_type,
      postData: JSON.parse(data?.keysandvalues),
      notificationSentTimestamp: data?.sent_at,
      notificationOpenedTimestamp: new Date().toISOString(),
      tap: data?.tap,
      screenContentId: postData?.screenContentId
    };

    if (postData.route.match('/main/commitments') && notificationId
        && !this.isCommitmentNotificationProcessed(notificationId)
        && !this.processedCommunityNotifications?.has(notificationId)) {
      this.processedCommitmentNotifications.add(notificationId);
      mixpanel.track('Habit commitment push notification is opened in onboarding learning notification', notificationData);
      localStorage.setItem('CommitmentsNotificationId', notificationId.toString());
      if (this.homeUiService.getModalStack()?.length > 0) {
        if (this.homeUiService.getModalStack()[this.homeUiService.getModalStack()?.length - 1]?.component?.name != 'MyCommitmentsComponent'
            && this.homeUiService.getModalStack()[this.homeUiService.getModalStack()?.length - 1]?.name != 'MyCommitmentsComponent') {
          this.homeUiService.setModalStack(MyCommitmentsComponent);
          this.homeUiService.openNextComponent(MyCommitmentsComponent);
        }
      } else {
        this.homeUiService.setModalStack(MyCommitmentsComponent);
        this.homeUiService.openNextComponent(MyCommitmentsComponent);
      }
      localStorage.setItem('processedCommitmentNotifications', JSON.stringify(Array.from(new Set(this.processedCommitmentNotifications))));
    }

    if (postData.route.match('/main/questions') && notificationId
        && !this.isCommitmentNotificationProcessed(notificationId)
        && !this.processedCommunityNotifications?.has(notificationId)) {
      this.processedCommunityNotifications.add(notificationId);
      mixpanel.track('Community push notification is opened in onboarding learning notification', notificationData);
      this.appState.set('communityNotification', true);
      this.appState.set('notificationData', requestData);
      if (this.homeUiService.getModalStack()?.length > 0) {
        if (this.homeUiService.getModalStack()[this.homeUiService.getModalStack()?.length - 1]?.component?.name == 'MobileChatBoardComponent'
            || this.homeUiService.getModalStack()[this.homeUiService.getModalStack()?.length - 1]?.name == 'MobileChatBoardComponent') {
          this.appState.set('isBackground', true);
        } else {
          this.homeUiService.setModalStack(MobileChatBoardComponent);
          this.homeUiService.openNextComponent(MobileChatBoardComponent);
        }
      } else {
        this.homeUiService.setModalStack(MobileChatBoardComponent);
        this.homeUiService.openNextComponent(MobileChatBoardComponent);
      }
      localStorage.setItem('processedCommunityNotifications', JSON.stringify(Array.from(new Set(this.processedCommunityNotifications))));
    }
  }  
  isCommitmentNotificationProcessed(id: number): boolean {
    console.log("this.processedCommitmentNotifications?.has(id)",this.processedCommitmentNotifications?.has(id),id)
    return this.processedCommitmentNotifications?.has(id);
  }
  addCalendarEvent() {
    try {
      this.createCalendarEvent();
    } catch (error) {
      this.toastrService.error(this.i18n.t("calendar: Something went wrong."));
    }
    this.analyticsService.setOnboardingEvent(
      "Onboarding",
      "create calendarEvent clicked",
      this.currentScreenId,
      this.currentPath.id,
      this.currentClient.id
    );
  }

  createCalendarEvent() {
    this.isWeeklyEnabled = this.currentPath?.enabledAttributes?.reminder_type == "weekly" ? true : false;
    this.selectedDate = this.selectedDate ? this.selectedDate : this.pathRegistration?.pathData?.loginReminderDate;
    this.confirmedTime = this.confirmedTime ? this.confirmedTime : this.pathRegistration?.pathData?.loginReminderTime;
    const success = function (message) {
      console.log("Success: " + JSON.stringify(message));
    };
    const error = function (message) {
      console.error("Error: " + message);
    };

    try {
      if (!this.confirmedTime) {
        this.toastrService.warning(
          this.i18n.t("Please select the time on previous screen!")
        );
        return;
      } else {
        // create an event interactively
        const w: any = window;
        const calOptions = w.plugins.calendar.getCalendarOptions();
        const showAlertPrompt = true;
        const daysCount = this.isWeeklyEnabled ? this.currentPath.lastDayOfContent() : this.currentPath.lastDayOfContent() * 1.5; // LUMBA-1399
        calOptions.recurrence = this.isWeeklyEnabled ? "weekly" : "DAILY";
        calOptions.recurrenceInterval = 1;
        calOptions.firstReminderMinutes = 0;
        calOptions.recurrenceEndDate =this.isWeeklyEnabled&& this.selectedDate && this.confirmedTime?moment(`${this.selectedDate} ${this.confirmedTime}`, "DD-MM-YYYY HH:mm").add(daysCount, "week").toDate() :moment(this.confirmedTime, "HH:mm")
          .add(daysCount, "day")
          .toDate();
        this.calendarService.scheduleEvents(
          this.calendarParams.title,
          this.calendarParams.eventLocation,
          this.calendarParams.notes,
          this.calendarParams.startDate,
          this.calendarParams.endDate,
          calOptions,
          success,
          error,
          showAlertPrompt
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  addManagerEmail(value: string) {
      // NOT appState "managerEmail": the hosts re-read that into addedManagerEmail on every change
      // detection cycle and gate the mandatory Next arrow on it, so writing it per keystroke opened
      // the gate for an address nobody had saved — and left it open across a reopen. Only
      // saveManagerEmailAddress() sets it, once the server has actually stored the address.
      this.appState.set("managerEmailDraft", value);
      this.isManagerEmailAdded = value;
  }

  saveAccountabilityEmailDraft(value: string) {
    this.appState.set("accountabilityEmailDraft", value);
  }

  addAccountablityEmail(email: any) {
    const normalizedEmail = email?.trim()?.toLowerCase();
    if (!this.sessionService.validateEmail(normalizedEmail)) {
      this.toastrService.warning(this.i18n.t("Please enter valid email!"));
      return;
    }
    if (this.arrayOfAccountabilyEmails.some(e => e?.trim()?.toLowerCase() === normalizedEmail)) {
      this.toastrService.warning(this.i18n.t("This email has already been added!"));
      return;
    }
    this.arrayOfAccountabilyEmails.push(normalizedEmail);
    this.accountablityEmail = "";
    this.appState.set("accountabilityEmails", this.arrayOfAccountabilyEmails);
    this.appState.set("accountabilityEmailsModified", true);
    mixpanel.track('In Steps-Accountability Email Added', {
      currentDay: this.currentDay,
      totalEmails: this.arrayOfAccountabilyEmails.length,
      userId: this.currentUser?.id,
      pathId: this.currentPath?.id
    });
    this.pushAccountablityEmails(this.currentDay, true);
  }

  removeEmail(email: any) {
    const index = this.arrayOfAccountabilyEmails?.indexOf(email);
    if (index > -1) {
      this.arrayOfAccountabilyEmails?.splice(index, 1);
      this.appState.set("accountabilityEmails", this.arrayOfAccountabilyEmails);
      this.appState.set("accountabilityEmailsModified", true);
      mixpanel.track('In Steps-Accountability Email Removed', {
        currentDay: this.currentDay,
        totalEmails: this.arrayOfAccountabilyEmails.length,
        userId: this.currentUser?.id,
        pathId: this.currentPath?.id
      });
      this.pushAccountablityEmails(this.currentDay);
    }
  }

  pushAccountablityEmails(currentDay?, isAdd = false) {
    this.currentUser = this.appState.get("currentUser");
    let isAccountailityChanges = false;
    if (this.currentUser?.accountabilityEmails?.length != this.arrayOfAccountabilyEmails?.length) {
      isAccountailityChanges = true;
    } else {
      for (let i = 0; i < this.arrayOfAccountabilyEmails.length; i++) {
        if (this.arrayOfAccountabilyEmails[i] !== this.currentUser?.accountabilityEmails[i]) {
          isAccountailityChanges = true;
        }
      }
    }

    if (isAccountailityChanges) {
      var data = {
        id: this.currentUser.id,
        accountability_email: this.arrayOfAccountabilyEmails,
        current_day: currentDay,
        screen_content_id: this.accountabilityEmailData?.screenContentId,
        step_id: this.accountabilityEmailData?.stepId
      };

      this.homeService.accountablityEmailAPI(data).subscribe(
        (response) => {
          this.appState.set("accountabilityEmails", response?.data);
          this.appState.set("accountabilityEmailsModified", false);
          this.appState.set("accountabilityEmailDraft", null);
          this.currentUser.accountabilityEmails = response?.data;
          // Mark the screen completed (server + state) only when an email was ADDED (not on
          // removal), so this path stays "done" even if the emails are later removed, while a
          // different cycle whose only emails are pre-existing still disables when they're deleted.
          if (isAdd && response?.data?.length > 0) {
            this.homeUiService.markScreenCompleted(
              this.accountabilityEmailData?.stepId,
              this.accountabilityEmailData?.screenId,
              this.accountabilityEmailData?.screenContentId,
              this.accountabilityEmailData
            );
          }
          console.log(response, this.currentUser);
        },
        (error) => {
          console.log(error);
          // Save failed — revert the local list to the last server-confirmed state so an
          // unsaved change never opens the mandatory gate.
          this.arrayOfAccountabilyEmails = [...(this.currentUser?.accountabilityEmails || [])];
          this.appState.set("accountabilityEmails", this.currentUser?.accountabilityEmails || []);
          this.toastrService.error(this.i18n.t("Accountability emails data could not be saved."));
        }
      );
      this.analyticsService.setOnboardingEvent(
        "Onboarding",
        "Accountablity emails added",
        this.currentScreenId,
        this.currentPath.id,
        this.currentClient.id
      );
    }
  }

  async fileChangeEvent(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    if (!files?.length) {
      return;
    }
    this.spinnerService.on();
    const picked = files[0];
    // Clear the input so re-picking the very same photo still fires (change).
    target.value = "";
    const prepared = await this.shrinkImage(picked);
    // createImageBitmap/toBlob are not zone-patched, so we resume outside the
    // Angular zone. Without re-entering it the upload still succeeds but nothing
    // re-renders: the loader stays put and the photo never appears.
    this.ngZone.run(() => this.uploadPhoto(prepared));
  }

  // The native camera path already hands us a downscaled image (quality 20 /
  // targetWidth 720), but a file picked through the HTML input is the untouched
  // original — several MB straight off the camera, which is what makes the upload
  // crawl on mobile data. Shrink it to the same ballpark before posting.
  private async shrinkImage(file: any): Promise<any> {
    if (!file?.type?.startsWith("image/") || file.type === "image/gif") {
      return file;
    }
    try {
      const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" } as any);
      const scale = Math.min(1, this.PHOTO_MAX_EDGE / Math.max(bitmap.width, bitmap.height));
      if (scale === 1 && file.size <= this.PHOTO_SKIP_RESIZE_BYTES) {
        bitmap.close();
        return file;
      }
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      const ctx = canvas.getContext("2d");
      // JPEG has no alpha, so flatten onto white instead of black.
      ctx!.fillStyle = "#ffffff";
      ctx!.fillRect(0, 0, canvas.width, canvas.height);
      ctx!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close();
      const blob: Blob = await new Promise<Blob>((resolve, reject) =>
        canvas.toBlob(
          (result) => (result ? resolve(result) : reject(new Error("toBlob returned null"))),
          "image/jpeg",
          this.PHOTO_JPEG_QUALITY
        )
      );
      if (blob.size >= file.size) {
        return file;
      }
      // Deliberately NOT `new File([blob], name, { type })`: cordova-plugin-file replaces the global
      // File with its own class — File(name, localURL, type, lastModifiedDate, size) — so on device
      // that call silently builds a Cordova File instead of a DOM one (name becomes the array of
      // parts, type the options object), which FormData then rejects with "parameter 2 is not of
      // type 'Blob'". It does not throw, so a try/catch cannot catch it. The Blob is already all
      // FormData needs; uploadPhoto passes this name as the explicit filename.
      (blob as any).name = this.toJpegName(file.name);
      return blob;
    } catch (error) {
      console.error("Profile photo could not be resized, uploading the original", error);
      return file;
    }
  }

  private toJpegName(name: string) {
    return `${(name || "photo").replace(/\.[^.]+$/, "")}.jpg`;
  }

  uploadPhoto(file: any) {
    let currentDay = this.appState.get("currentScheduleDay");
    const myFormData = new FormData();
    // The picker hands back either a DOM File (HTML input) or { blob, name } (native action sheet).
    // Anything else — a Cancel sentinel, a FileEntry a WebView handed us instead of a Blob — used to
    // reach FormData.append and throw "parameter 2 is not of type 'Blob'". That TypeError escaped as
    // an unhandled rejection, so spinnerService.off() never ran: the loader sat there forever over a
    // profile that never updated, and its backdrop then ate the taps meant for the next attempt.
    const payload = file?.blob ?? file;
    if (!(payload instanceof Blob)) {
      console.error("Profile photo: picker returned something that is not a Blob", file);
      this.spinnerService.off();
      this.toastrService.error(this.i18n.t("Profile picture could not be uploaded."));
      return;
    }
    myFormData.append("file", payload, (payload as any).name || file?.name || "photo.jpg");
    mixpanel.track("Onboarding-profile image uploaded", {
      profileImage: myFormData,
    });
    this.spinnerService.on();
    this.userService.postProfilePic(myFormData).subscribe(
      (result) => {
        this.sessionService.url = result["data"]["url"];
        this.currentUser.imageUrl = this.sessionService.url;
        this.currentUser.profileUploadedDay = currentDay;
        this.updateProfile();
      },
      () => {
        this.spinnerService.off();
        this.toastrService.error(this.i18n.t("Profile picture could not be uploaded."));
      }
    );
  }

  requestPermissions() {
    this.permissions.checkPermission(this.permissions.PERMISSION.CAMERA)
      .then(result => {
        if (!result.hasPermission) {
          this.permissions.requestPermissions([
            this.permissions.PERMISSION.READ_MEDIA_IMAGES,
            this.permissions.PERMISSION.CAMERA]).then(async (res) => {
              if (res) {
                const fileResult = await this.native.showActionSheetForFiles();
                // this.spinnerService.on();
                if (fileResult) {
                  mixpanel.track("instep-Onboarding-profile image uploaded", {
                    profileImage: fileResult,
                  });
                  this.uploadPhoto(fileResult);
                  this.analyticsService.setOnboardingEvent(
                    "Onboarding",
                    `Profile image uploaded`,
                    this.currentScreenId,
                    this.currentPath.id,
                    this.currentClient.id
                  );
                } else {
                  this.spinnerService.off();
                }
              }
            })

        }
        else {

        }
      })
      .catch(err => console.error('Error checking permission:', err));
  }

  async chooseUploadOption() {
    this.stopInterval();
    if (this.platform.is('android')) {
      this.requestPermissions();
    }
    else {
      const fileResult = await this.native.showActionSheetForFiles();
      // this.spinnerService.on();
      if (fileResult) {
        mixpanel.track("instep-Onboarding-profile image uploaded", {
          profileImage: fileResult,
        });
        this.uploadPhoto(fileResult);
        this.analyticsService.setOnboardingEvent(
          "Onboarding",
          `Profile image uploaded`,
          this.currentScreenId,
          this.currentPath.id,
          this.currentClient.id
        );
      } else {
        this.spinnerService.off();
      }
    } 
  }
  stopInterval() {
    if (this.dataRefresher) {
      clearInterval(this.dataRefresher);
    }
  }
  updateProfile() {
    this.spinnerService.on();
     delete this.currentUser.userBgColor;
     delete this.currentUser.pathGeneratedByKyper;
      delete this.currentUser.clientEnabledForKyper;
     this.currentUser.stepId= this.profileScreenData?.stepId;
     this.currentUser.screenContentId = this.profileScreenData?.screenContentId
    this.userService.save(this.currentUser).subscribe(
      (response: any) => {
        // Dismiss first — a malformed response must not leave the loader up.
        this.spinnerService.off();
        this.userUpdate = response?.data;
        const updatedUser = new User(this.userUpdate?.updateUser);
        if (!updatedUser?.id) {
          this.toastrService.error(this.i18n.t("Profile picture could not be saved."));
          return;
        }
        this.currentUser = updatedUser;
        this.appState.set('updateActionPoints', true)
        this.label = "";
        this.appState.set("currentUser", updatedUser);
        localStorage.setItem("userid", updatedUser.id.toString());
        this.isPhotoUploaded = true;

        this.toastrService.success(this.i18n.t("Profile Picture Added!"));
      },
      () => {
        // Without this the spinner would sit there forever on a failed save.
        this.spinnerService.off();
        this.toastrService.error(this.i18n.t("Profile picture could not be saved."));
      }
    );
  }

  onProfileImageError() {
    this.label = "Tap to Add Photo";
    this.isPhotoUploaded = false;
  }

  deletePhoto() {
    if (!this.isPhotoUploaded) {
      return;
    }
    // Kept so a failed delete can put the photo back on screen.
    const previousImageUrl = this.currentUser.imageUrl;
    this.spinnerService.on();
    delete this.currentUser.userBgColor;
    delete this.currentUser.pathGeneratedByKyper;
    delete this.currentUser.clientEnabledForKyper;
    this.currentUser.imageUrl = "nil";
    this.currentUser.stepId = this.profileScreenData?.stepId;
    this.currentUser.screenContentId = this.profileScreenData?.screenContentId;
    this.userService.save(this.currentUser).subscribe(
      (response: any) => {
        this.spinnerService.off();
        this.userUpdate = response?.data;
        const updatedUser = new User(this.userUpdate?.updateUser);
        if (!updatedUser?.id) {
          this.currentUser.imageUrl = previousImageUrl;
          this.toastrService.error(this.i18n.t("Profile picture could not be removed."));
          return;
        }
        updatedUser.imageUrl = "nil";
        this.currentUser = updatedUser;
        this.appState.set("currentUser", updatedUser);
        localStorage.setItem("userid", updatedUser.id.toString());
        this.label = "Tap to Add Photo";
        this.isPhotoUploaded = false;
        this.toastrService.success(this.i18n.t("Profile Picture Removed!"));
      },
      () => {
        this.currentUser.imageUrl = previousImageUrl;
        this.spinnerService.off();
        this.toastrService.error(this.i18n.t("Profile picture could not be removed."));
      }
    );
  }

  ngDoCheck(): void {
     this.userShuffledChapters = this.appState.get('userShuffledChapters');
    if (localStorage.getItem("learningTime") != "null") {
      this.confirmedTime = localStorage.getItem("learningTime");
    }
    if (this.currentScreen == "daily-content-screen-learning-settings") {
      this.resetCalenderData = false;
    }
    if (this.isNotificationSettingsCalenderScreen == true && this.currentScreen == 'daily-content-screen-learning-settings-confirmation-calender' && !this.resetCalenderData) {
      this.selectedDate =this.appState.get("selectedReminderDate")
      this.initCalendarButton();
      this.resetCalenderData = true;
      }
  }

  ngOnDestroy() {
    // if (this.managerEmail?.includes("@")) {
    //   this.appState.set("managerEmail", this.managerEmail);
    //    console.log("manager email on destroy", this.managerEmail);
    //   this.addedManagerEmail = this.managerEmail;
    // }
    this.appState.set("selectedReminderDate", null)
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.chaptersResizeObserver?.disconnect();
  }
}